export const SESSION_EXPIRED_EVENT = 'app:session-expired';

/**
 * 세션 만료 이벤트 발행 플래그 (중복 방지)
 */
let hasEmittedSessionExpired = false;

/**
 * 세션 만료 이벤트 발행
 * shared 레이어에서 상위 레이어(app)로 세션 만료를 알리기 위한 이벤트 발행
 * 중복 발행 방지: 한 번만 실행됨
 */
export const emitSessionExpired = () => {
  if (hasEmittedSessionExpired) {
    console.warn('[emitSessionExpired] ⏸️ 이미 세션 만료 이벤트 발행됨 - 중복 방지');
    return;
  }

  hasEmittedSessionExpired = true;

  if (typeof window !== 'undefined') {
    console.warn('[emitSessionExpired] 🔔 STEP 4: 세션 만료 이벤트 발행 → AuthProvider로 전달');
    window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT));
  }
};

/**
 * 세션 만료 이벤트 구독
 * @param handler - 세션 만료 시 실행할 핸들러 함수
 * @returns 이벤트 리스너 해제 함수
 */
export const onSessionExpired = (handler: () => void) => {
  if (typeof window !== 'undefined') {
    window.addEventListener(SESSION_EXPIRED_EVENT, handler);
  }
  return () => {
    if (typeof window !== 'undefined') {
      window.removeEventListener(SESSION_EXPIRED_EVENT, handler);
    }
  };
};
